module.exports = __webpack_public_path__ + "img/aboutMMQT.20b3a04b.png";